import Grid2 from "@mui/material/Unstable_Grid2";
import {Typography} from "@mui/material";
import SteddiContainer from "../../General/SteddiContainer";
import EnergiKonto from "../../Esign/InfoItems/EnergiKonto";
import {CalendarDays, CalendarX} from "lucide-react";
import SteddiInfoItem from "../../General/SteddiInfoItem";
import Månedsbeløp from "../../Esign/InfoItems/Månedsbeløp";
import DateHelpers, {monthNames} from "../../../helpers/DateHelpers";
import React from "react";
import useOrderState from "../../../stores/orderStore";

export default function PaymentFreeCompletedPage(){
  const state = useOrderState((state) => state)

  function getEstimate(){
    switch(state.paymentFreeMonths.length){
      case 0:
        return state.paymentFree?.estimates.none
      case 1:
        return state.paymentFree?.estimates.single
      case 2:
        return state.paymentFree?.estimates.double
    }
  }

  return (
    <Grid2 container spacing={2}>
      <Grid2 xs={12}>
        <Typography>Sjekk at informasjonen stemmer.</Typography>
      </Grid2>
      <Grid2 xs={12}>
        <SteddiContainer padding={"sm"}>
          <EnergiKonto/>
        </SteddiContainer>
      </Grid2>
      <Grid2 xs={12}>
        <SteddiContainer padding={"sm"}>
          <SteddiInfoItem icon={<CalendarX/>} bgColor={"secondary"}
                          title={"Betalingsfri måned"}
                          subtitle={state.paymentFreeMonths.length > 0 ? state.paymentFreeMonths.map(m => monthNames[m - 1]).join(", ") : "Nei"}/>
        </SteddiContainer>
      </Grid2>
      <Grid2 xs={12}>
        <SteddiContainer padding="sm">
          <Månedsbeløp override={getEstimate()}/>
        </SteddiContainer>
      </Grid2>
      <Grid2 xs={12}>
        <SteddiContainer padding="sm">
          <SteddiInfoItem title={"Neste forfall"} subtitle={DateHelpers.toDateString(DateHelpers.getFirstPaymentDate())} icon={<CalendarDays/>} bgColor={"secondary"}/>
        </SteddiContainer>
      </Grid2>
    </Grid2>
  )
}